import { sendSentryClientErrorOnce } from 'shared/lib';

import type { TProductTypeTabId } from 'entities/creditForm';

import { PRODUCT_TYPE_TABS } from '../config';
import type { TProductTypeTab } from '../types';

export const getProductTypeTabById = (tabId: TProductTypeTabId): TProductTypeTab => {
  const tab = PRODUCT_TYPE_TABS.find(({ id }) => id === tabId);

  if (!tab) {
    sendSentryClientErrorOnce('getProductTypeTabById', 'Unknown product type tab id', { tabId });

    return PRODUCT_TYPE_TABS[0];
  }

  return tab;
};
